// extracted by mini-css-extract-plugin
module.exports = {"infiniteScrollLoader":"InfiniteScrollLoader_infiniteScrollLoader__3yHsR","spin":"InfiniteScrollLoader_spin__1d69F"};